module.exports = __webpack_public_path__ + "68a23119b465484782268ee03d0b0abd.pdf";